<template>
    <div>
        <div class="modal-container has-text-centered has-text-white">
            <div class="top5"><b>{{metric == 'imp' ? 'IMPRESSIONS' : 'CLICKS' }}</b></div>
            <div class="delete is-pulled-right top-18 right5" @click="cancel"></div>
            <table class="top10">
                <tr v-for="(i,ind) in arr" :key="ind">
                    <td>{{az.dateConvert(i.createDate)}}</td>
                    <td>---</td>
                    <td>{{i.name}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
  props: {id: Number, metric: String},
  data: function(){
      return {
         arr: [],
         az: az
      }
  },
  mounted: function(){
       var self = this;

        //check for profile
        function w(d){
          
                //prompt to complete profile
       
               self.arr = d.data
             
          
        }
        function n(){
            
        }

        this.$root.app.apiClient.get('subs/data/metricsdetails/' + self.id + '-' + self.metric, {}, w, n)
       
  },
  methods: {
     
      cancel: function(){
          this.$emit('close')
      }
  }
}
</script>

<style scoped>
    #title{
        font-size: 1.5rem;
    }
    .modal-container{
        width: 500px;
        max-height: 80vh;
        overflow: scroll
    }
    .body-bott{
        position: absolute;
        right: 15px;
        bottom: 20px;
        width: 100%;
    }
    .notification{
        height: 100%;
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
   

</style>
